import clsx from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function for merging class names. It is useful for conditional classes.
 * Combines the functionality of `clsx` and `tailwind-merge`.
 *
 * @param  {import("clsx").ClassValue[]} inputs - Class names to merge
 * @returns {string} - Merged class names
 *
 * @example
 * cn("class1", { "class2": true, "class3": false }, "class4");
 * // returns "class1 class2 class4"
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
